import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TakeawayCategoryMenu from '../components/TakeawayCategoryMenu';
import TakeawayTabs from '../components/TakeawayTabs';
import TakeawayMenuList from '../components/TakeawayMenuList';
import TakeawayCart from '../components/TakeawayCart';
import WeightedProductsList from '../components/WeightedProductsList';
import EditModal from '../components/modals/EditModal';
import DealPopupModal from '../components/modals/DealPopupModal';
import HalfNHalfModal from '../components/modals/HalfNHalfModal';
import menuStore from '../utils/localForageInstance';
import MainLayoutWithoutFooter from '../components/MainLayoutWithoutFooter';
import { getSessionId } from '../utils/sessionId';
import useSoldOutIds from '../hooks/useSoldOutIds';
import useMenuCardSettings from '../hooks/useMenuCardSettings';
import useUpfrontOrderSetting from '../hooks/useUpfrontOrderSetting';
import UpfrontOrderSetupModal from '../components/modals/UpfrontOrderSetupModal';
import { getUpfrontSetup, saveUpfrontSetup, clearUpfrontSetup } from '../utils/upfrontSetup';

 import { apiUrls } from "../utils/apiUrls";
 import { callAPI } from "../utils/apiUtils";
 import GuardedNavigationModal from '../components/modals/GuardedNavigationModal';
 import useNavigationGuard from '../hooks/useNavigationGuard';
 import useCart from '../hooks/useCart';
import { cachedCall } from '../utils/dataCache';
import { useConnection } from '../offline/connection';
import { canDo } from '../offline/state';
import { toast } from 'react-toastify';

  const Takeaway = () => {
    const [categories, setCategories] = useState([]);
    const [weightedProducts, setWeightedProducts] = useState([]);
    const [weightedPlaceholderItemId, setWeightedPlaceholderItemId] = useState(null);
    const [selectedCuisineIndex, setSelectedCuisineIndex] = useState(0);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [showCategory, setShowCategory] = useState(false);
    const [showCartSidebar, setShowCartSidebar] = useState(false);
    const [dealPopup, setDealPopup] = useState({ isOpen: false, dealId: null, dealSizeId: null, remaining: null, deletedProductId: null, parentCartId: null });
    const [showHalfNHalf, setShowHalfNHalf] = useState(false);
    const [halfAndHalfAvailable, setHalfAndHalfAvailable] = useState(false);
    const { compactCards, hideAllergenIcons } = useMenuCardSettings();

    const location = useLocation();
    const navigate = useNavigate();
    // Offline, only what the offline engine says it can do is offered (a no-op online / with no engine).
    const { state: offlineState } = useConnection();
    const offlineCan = (capability) => canDo(offlineState, capability);
    const [cartRefresh, setCartRefresh] = useState(0);
    const autoLoadDeal = location.state?.auto_load_deal || null;
    const autoLoadedRef = useRef(false);
    const [resolvedExistingOrder, setResolvedExistingOrder] = useState({ orderId: null, tableId: null });

    // Two different questions were being answered by one value, which is what caused items to be
    // double-attached (once to the parent order at add time, again to the child order Send to
    // Kitchen creates) - both for tapping an occupied table AND for "Add More Items" on an
    // existing PREPAID/takeaway order (CheckoutItem.js, OrderDetails.js):
    //
    // displayOrderId - which order's cart the SIDEBAR shows. existing_order_id is what every
    // "resume this order" entry point sends (CheckoutItem.js, OrderDetails.js); tapping an
    // occupied table sends neither and falls back to the order TakeawayCart resolved by table id.
    // Passing it is read-only: CartService::getCartItemsFromSession($orderId, $session_id) merges
    // what's already attached to that order (already sent to kitchen) with whatever's still
    // pending in this session (added since, not yet attached to anything) - it doesn't attach
    // anything itself. That merge is what gives the "previously added" / "newly added" split its
    // data.
    //
    // editOrderId - passed to add-to-cart calls and to Order Review. No entry point sends
    // edit_order_id any more precisely because sending it is what caused the duplicate: it made
    // add-to-cart attach the new item straight into the order (CartService::addSelectedDishesToCart),
    // and forwarding it to Order Review would pull the order's already-sent items into a screen
    // meant to show only what's about to be sent. This stays wired to nav state (rather than
    // deleted outright) as a deliberate opt-in some future explicit-attach flow could still use -
    // as long as nothing sets it, both stay untouched until Send to Kitchen creates the child
    // order and attaches the cart ids there (CustomOrderService::registerOrderBeforePayment) - the
    // one place attachment should happen.
    const displayOrderId = location.state?.existing_order_id || location.state?.edit_order_id || resolvedExistingOrder.orderId || null;
    const editOrderId = location.state?.edit_order_id || null;

    // Merging the session's pending items in is only wrong when editOrderId is set, because that's
    // the one case where those items were already eagerly attached elsewhere at add time (see
    // above) - merging would then pull in every other pending item from this browser session,
    // including ones already attached to a totally different order. Nothing sets editOrderId any
    // more, so this is always true in practice; kept conditional so it stays correct if that ever
    // changes. See the mergePending comment in useCart.js and the merge_pending guard in
    // CartController::actionCheckoutCartDetails.
    const mergePending = !editOrderId;

    // Shown as the cart's heading so staff can see which table they're adding to.
    const tableName = location.state?.tableName || localStorage.getItem('selectedTableName') || '';

    const [customItemProduct, setCustomItemProduct] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const { soldOutIds, stockLevels, refreshSoldOut } = useSoldOutIds();

    // Stock counts change as the cart is built and orders are placed (here or on another terminal), so
    // re-read the sold-out list whenever the cart changes instead of waiting for the next minute tick.
    useEffect(() => {
      refreshSoldOut();
    }, [cartRefresh, refreshSoldOut]);

    console.log("Es1",editOrderId)
    const cartData = useCart(cartRefresh, displayOrderId, { mergePending });

    const cartItemsExist =
      Array.isArray(cartData.cartItems) &&
      cartData.cartItems.length > 0;

    const orderType = location.state?.orderType || localStorage.getItem('orderType') || 'takeaway';

    // "Customer details first" (Settings, off by default): a fresh takeaway / delivery order opens with a popup for the service type
    // and time, the customer and the delivery address; they are kept for the order and checkout goes straight to payment. Never for
    // dine-in, for an order being resumed or edited, or while offline (no customer search / delivery) - those keep the usual flow.
    const { enabled: upfrontEnabled } = useUpfrontOrderSetting();
    const upfrontActive = upfrontEnabled && orderType === 'takeaway' && !displayOrderId && !editOrderId && canDo(offlineState, 'customerSearch');
    const [upfrontSetup, setUpfrontSetup] = useState(() => getUpfrontSetup());
    const [upfrontOpen, setUpfrontOpen] = useState(false);
    useEffect(() => {
      if (!upfrontActive) {
        setUpfrontOpen(false);
        return;
      }
      const saved = getUpfrontSetup();
      setUpfrontSetup(saved);
      setUpfrontOpen(!saved);
    }, [upfrontActive]);
    const handleUpfrontSave = (setup) => {
      saveUpfrontSetup(setup);
      setUpfrontSetup(setup);
      setUpfrontOpen(false);
    };
    const handleUpfrontSkip = () => {
      clearUpfrontSetup();
      setUpfrontSetup(null);
      setUpfrontOpen(false);
    };
    //const selectedTables = location.state?.selectedTables || {};
    const selectedTables =  location.state?.selectedTables ||  JSON.parse(localStorage.getItem('selectedTables') || '{}');
    // selectedTables' own shape is ambiguous by the time it gets here - a flat [tableId] array
    // from a single tap, or a {tabId: [ids]} object from multi-select - so it can't reliably say
    // which zone this order belongs to. tabId is passed alongside it by every entry point in
    // useTableOrdering.js specifically to answer that (with the same localStorage-fallback
    // pattern as tableName, in case of a full page reload losing location.state).
    const tabId = location.state?.tabId || localStorage.getItem('selectedTabId') || null;
    const isPagerOrder = tabId === 'pager-tab';

    const { showModal, confirmNavigation, cancelNavigation, guardedNavigate } = useNavigationGuard(orderType && cartItemsExist);

    const toggleCategory = () => {
      setShowCategory(prev => !prev);
      setShowCartSidebar(false);
    };
    
    const toggleCartSidebar = () => {
      setShowCartSidebar(prev => !prev);
      setShowCategory(false);
    };
    
    const closeOverlays = () => {
      setShowCategory(false);
      setShowCartSidebar(false);
    };

    useEffect(() => {
      const root = document.documentElement;
    
      if (showCategory) {
        root.classList.add("actCategory");
      } else {
        root.classList.remove("actCategory");
      }
    
      if (showCartSidebar) {
        root.classList.add("actCartSidebar");
      } else {
        root.classList.remove("actCartSidebar");
      }
    }, [showCategory, showCartSidebar]);


    const handleConfirm = async () => {
      // Backend decides whether there's actually anything prepaid/unpaid to
      // discard for this order - just attempt it whenever we're continuing
      // an existing order. editOrderId comes from nav state (may be missing
      // on paths that don't pass it); resolvedExistingOrder is the same
      // order independently looked up by table id inside TakeawayCart, so
      // fall back to that when editOrderId wasn't explicitly passed.
      const orderIdToClear = editOrderId || resolvedExistingOrder.orderId;
      if (orderIdToClear) {
        const tableId = resolvedExistingOrder.tableId
          || (Array.isArray(selectedTables)
            ? selectedTables[0]
            : Object.values(selectedTables || {})[0]);
        try {
          await callAPI(
            apiUrls.EMPTY_OCCUPANCY,
            {},
            'POST',
            {
              order_id: orderIdToClear,
              table_id: tableId,
            }
          );
        } catch (err) {
          console.error('Failed to clear table occupancy', err);
        }
      }

      localStorage.removeItem('orderType');
      localStorage.removeItem('selectedTables');
      confirmNavigation();
    };

    useEffect(() => {
      if (!orderType) {
        navigate('/dashboard', { replace: true });
      }
    }, [orderType, navigate]);

    useEffect(() => {
      console.log('selectedTables', selectedTables)
      if (orderType) {
        localStorage.setItem('orderType', orderType);
      }
      if (orderType === 'dinein' && selectedTables) {
        localStorage.setItem('selectedTables', JSON.stringify(selectedTables));
      }
      if (orderType === 'takeaway' && selectedTables) {
        localStorage.removeItem('selectedTables');
      }
      if (tabId) {
        localStorage.setItem('selectedTabId', tabId);
      }
    }, [orderType, selectedTables, tabId]);

    
    const handleItemClick = (item) => {
      console.log(item)
      setSelectedItem(item);
      setModalOpen(true);
      console.log(isModalOpen)
    };
  
    const closeModal = () => {
      setModalOpen(false);
      setSelectedItem(null);
    };
    
    const handleCartItemEdit = async (clickedCartItem) => {
      try {
        const session_id = getSessionId();
        let url = apiUrls.CART_ITEM_DETAILS + `?session_id=${session_id}`;
        console.log("EDD", displayOrderId)
        if (displayOrderId) {
          url += `&edit_order_id=${displayOrderId}`;
          if (mergePending) {
            url += `&merge_pending=1`;
          }
        }
        const response = await callAPI(
          url,
          {},
          'GET'
        );

        const cartItems = response?.data?.data?.items || [];
        
        const matchedCartItem = cartItems.find(
          (item) => item.cart_id === clickedCartItem.cart_id
        );
    
        if (!matchedCartItem) return;
        
        const productData = await menuStore.getItem(`product_${matchedCartItem.item_id}`);
        if (!productData) return;
    
        const enrichedItem = {
          ...matchedCartItem,
          fullProductData: productData
        };
    
        setSelectedItem(enrichedItem);
        setModalOpen(true);
    
      } catch (error) {
        console.error('Error editing cart item:', error);
      }
    };
    
    
    // Fetch category + dishes
    useEffect(() => {
        const fetchData = async () => {
            try {
               // const res = await callAPI(apiUrls.CATEGORY_LISTING, 'GET');
               // setCategories(res.data.data || []);
               const categoryData = await menuStore.getItem('dish_category_items');//ek constant ki bhi util banani hai
               if (categoryData) {
                 setCategories(categoryData);
               }
               
               //custom item ke liye
             const response = await callAPI(apiUrls.GET_CUSTOM_ITEM_PRODUCT, {}, 'GET', null, {}, {}, false);
             // const itemId =  9359;//response?.data?.data?.item_id;
             const itemId = response?.data?.data?.item_id;

              // The server hands back the restaurant's custom item product (creating a hidden one if it
              // has none), and a custom line is named and priced from the modal - the cart only needs
              // that id. So the button no longer depends on the product being in the menu cache, which
              // dropped it when the product's category was inactive or the menu hadn't been synced.
              if (itemId) {
                  setCustomItemProduct({ product_id: itemId });
              }
              
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();

        // "Price by Weight" - its own request rather than part of fetchData above, so a failure
        // here, or a restaurant that has never used the feature, cannot stop the rest of the
        // ordering screen from loading.
        (async () => {
          try {
            const weightedRes = await callAPI(apiUrls.WEIGHTED_PRODUCTS, {}, 'GET');
            setWeightedProducts(weightedRes.data?.data?.products || []);
            setWeightedPlaceholderItemId(weightedRes.data?.data?.placeholder_item_id || null);
          } catch (error) {
            console.error('Error fetching weighted products:', error);
          }
        })();

        cachedCall('hnh_config', () => callAPI(apiUrls.HALF_AND_HALF_CONFIG, {}, 'GET', null, {}, {}, false), { accept: (r) => r?.status === 200 && r.data?.status === 1 })
          .then(res => setHalfAndHalfAvailable(res.data?.status === 1))
          .catch(() => setHalfAndHalfAvailable(false));
    }, []);

    // Synthetic cuisine tab for "Price by Weight", appended only once the restaurant actually has
    // a weighted product - same "no empty tabs" rule used elsewhere in the app.
    const displayCategories = useMemo(() => {
      if (weightedProducts.length === 0 || !canDo(offlineState, 'weightedItems')) return categories;
      return [...categories, { cuisine_id: 'price-by-weight', cuisine_name: 'Price by Weight' }];
    }, [categories, weightedProducts, offlineState]);

    const selectedCuisine = displayCategories[selectedCuisineIndex];
    const isWeightedProductsTab = selectedCuisine?.cuisine_id === 'price-by-weight';
    // console.log(activeTabIndex);
    // const tabs = selectedCuisine?.cuisine_category_dishes || [];
    let tabs = [];
    let activeCategory = [];
    if (
      selectedCuisine?.cuisine_category_dishes &&
      selectedCuisine.cuisine_category_dishes.length > 0
    ) {
      tabs = selectedCuisine?.cuisine_category_dishes || [];
      activeCategory = tabs[activeTabIndex]?.category_dishes || [];
      // console.log(activeCategory);
      // console.log(tabs);
    } else if (selectedCuisine?.cuisine_dishes) {
      activeCategory = selectedCuisine.cuisine_dishes;
    }

    // Search across every cuisine, subcategory and item cached in local DB.
    const normalizedSearch = searchQuery.trim().toLowerCase();
    const isSearching = normalizedSearch.length >= 3;

    const searchResults = useMemo(() => {
      if (!isSearching) return [];

      const results = [];
      const seenItemIds = new Set();
      const addDish = (dish) => {
        if (dish && !seenItemIds.has(dish.item_id)) {
          seenItemIds.add(dish.item_id);
          results.push(dish);
        }
      };

      categories.forEach((cuisine) => {
        const cuisineMatches = cuisine.cuisine_name?.toLowerCase().includes(normalizedSearch);

        if (cuisine.cuisine_category_dishes?.length) {
          cuisine.cuisine_category_dishes.forEach((subCategory) => {
            const subCategoryMatches = cuisineMatches || subCategory.category_name?.toLowerCase().includes(normalizedSearch);
            (subCategory.category_dishes || []).forEach((dish) => {
              if (subCategoryMatches || dish.itemname?.toLowerCase().includes(normalizedSearch)) {
                addDish(dish);
              }
            });
          });
        } else if (cuisine.cuisine_dishes) {
          cuisine.cuisine_dishes.forEach((dish) => {
            if (cuisineMatches || dish.itemname?.toLowerCase().includes(normalizedSearch)) {
              addDish(dish);
            }
          });
        }
      });

      return results;
    }, [categories, normalizedSearch, isSearching]);

    const triggerCartRefresh = () => setCartRefresh(prev => prev + 1);

    const handleDealClick = (dish, size) => {
      if (!offlineCan('deals')) {
        toast.info("Deals aren't available offline.");
        return;
      }
      setDealPopup({ isOpen: true, dealId: dish.item_id, dealSizeId: size.id });
    };

    const closeDealPopup = () => {
      setDealPopup({ isOpen: false, dealId: null, dealSizeId: null, remaining: null, deletedProductId: null, parentCartId: null });
    };

    // Called after a deal child is deleted — reopen deal popup with remaining items pre-selected.
    const handleDealChildDelete = (dealItemId, remaining, deletedProductId, parentCartId) => {
      setDealPopup({ isOpen: true, dealId: dealItemId, dealSizeId: null, remaining: remaining || null, deletedProductId: deletedProductId || null, parentCartId: parentCartId || null });
    };

    // Called from "Add Item" on a deal in cart — open popup at the first unfilled step.
    const handleDealAddItem = (dealItemId, parentCartId, remaining) => {
      setDealPopup({ isOpen: true, dealId: dealItemId, dealSizeId: null, remaining: remaining || null, deletedProductId: null, parentCartId: parentCartId || null });
    };

    const LoadDishesByDeals = useCallback((hostUrl, sub_cat_in_logic, product_id, size_id) => {
      const cuisineIndex = categories.findIndex((cat) => String(cat.cuisine_id) === String(hostUrl));
      const targetCuisine = cuisineIndex !== -1 ? categories[cuisineIndex] : null;

      if (cuisineIndex !== -1) {
        setSelectedCuisineIndex(cuisineIndex);
      }

      let resolvedTabIndex = 0;
      if (targetCuisine?.cuisine_category_dishes?.length) {
        const tabByIdIndex = targetCuisine.cuisine_category_dishes.findIndex(
          (tab) => String(tab.category_id) === String(sub_cat_in_logic)
        );
        if (tabByIdIndex !== -1) {
          resolvedTabIndex = tabByIdIndex;
        }
      }

      setActiveTabIndex(resolvedTabIndex);

      const targetButton = document.getElementById('catid_' + hostUrl);
      if (targetButton) {
        targetButton.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

      if (typeof product_id === 'undefined' || product_id === null) {
        return;
      }

      let openCategory = [];
      if (targetCuisine?.cuisine_category_dishes?.length) {
        openCategory = targetCuisine.cuisine_category_dishes[resolvedTabIndex]?.category_dishes || [];
      } else if (targetCuisine?.cuisine_dishes) {
        openCategory = targetCuisine.cuisine_dishes;
      }

      let product = openCategory.find((dish) => String(dish.item_id) === String(product_id));

      // Fallback: sometimes backend maps a different subcategory, so search all tabs.
      if (!product && targetCuisine?.cuisine_category_dishes?.length) {
        for (const tab of targetCuisine.cuisine_category_dishes) {
          const matched = (tab.category_dishes || []).find((dish) => String(dish.item_id) === String(product_id));
          if (matched) {
            product = matched;
            break;
          }
        }
      }

      if (product) {
        setSelectedItem({
          ...product,
          size_id,
        });
        setModalOpen(true);
      } else {
        console.error('Product not found for product_id:', product_id);
      }
    }, [categories]);

    useEffect(() => {
      try {
        window.LoadDishesByDeals = LoadDishesByDeals;
      } catch (err) {
        // ignore in non-browser environments
      }
      return () => {
        try {
          delete window.LoadDishesByDeals;
        } catch (err) {}
      };
    }, [LoadDishesByDeals]);

    useEffect(() => {
      if (autoLoadDeal && categories.length > 0 && !autoLoadedRef.current) {
        autoLoadedRef.current = true;
        LoadDishesByDeals(
          autoLoadDeal.hostUrl,
          autoLoadDeal.sub_cat_in_logic,
          autoLoadDeal.product_id,
          autoLoadDeal.size_id
        );
      }
    }, [autoLoadDeal, categories, LoadDishesByDeals]);

    return (
        <MainLayoutWithoutFooter guardedNavigate={guardedNavigate}>
            <div className="pageContent takeawayPage pb-0">
                <div className="container takeawayContainer">
                    <div className="row g-0 takeawayContent">
                        <div className="col-auto">
                              <TakeawayCategoryMenu
                            categories={displayCategories}
                            selected={selectedCuisineIndex}
                            searchQuery={searchQuery}
                            onSearchChange={setSearchQuery}
                            halfAndHalfAvailable={halfAndHalfAvailable && offlineCan('halfAndHalf')}
                            onHalfNHalfClick={() => { setShowHalfNHalf(true); closeOverlays(); }}
                            onSelect={(index) => {
                            setSelectedCuisineIndex(index);
                            setActiveTabIndex(0); // Reset tab when cuisine changes
                            closeOverlays();
                            }}
                        />
                        </div>
                        <div className="col">
                            <div className="menuSection screenHeightCol- tabStyle pb-4" id="menuTab" role="tablist">

                                <div className="sbRow mb-2 d-none border-bottom pb-2 pb-sm-3">
                                  <span className="categoryTrigger" onClick={toggleCategory}>
                                    <svg width="20" height="20" className="smTitleIcon">
                                      <use xlinkHref="./images/sprite.svg#iconCategoryIcon"></use>
                                    </svg>
                                    <span>Dishes Category</span>
                                  </span>

                                  <span className="cartSidebarTrigger" onClick={toggleCartSidebar}>
                                    <svg width="20" height="20" className="cartIcon">
                                      <use xlinkHref="./images/sprite.svg#iconCart"></use>
                                    </svg>
                                  </span>
                                </div>
                                {isWeightedProductsTab ? (
                                  <WeightedProductsList
                                    products={weightedProducts}
                                    orderType={orderType}
                                    editOrderId={editOrderId}
                                    onCartChange={triggerCartRefresh}
                                    placeholderItemId={weightedPlaceholderItemId}
                                  />
                                ) : (
                                  <>
                                    {!isSearching && (
                                      <TakeawayTabs
                                        tabs={tabs}
                                        activeIndex={activeTabIndex}
                                        onTabChange={setActiveTabIndex}
                                      />
                                    )}
                                    <TakeawayMenuList
                                      category={isSearching ? searchResults : activeCategory}
                                      onItemClick={handleItemClick}
                                      onCartChange={triggerCartRefresh}
                                      orderType={orderType}
                                      editOrderId={editOrderId}
                                      LoadDishesByDeals={LoadDishesByDeals}
                                      currentCuisineId={selectedCuisine?.cuisine_id}
                                      onDealClick={handleDealClick}
                                      soldOutIds={soldOutIds}
                                      stockLevels={stockLevels}
                                      compactCards={compactCards}
                                      hideAllergenIcons={hideAllergenIcons}
                                      onAddRejected={refreshSoldOut}
                                      onPendingAdd={cartData.addPendingRow}
                                      onPendingSettle={cartData.settlePendingRow}
                                      onPendingFail={cartData.failPendingRow}
                                    />
                                  </>
                                )}




                            </div>
                        </div>
                        <div className="col-auto">
                        <TakeawayCart upfrontSetup={upfrontActive ? upfrontSetup : null} upfrontAvailable={upfrontActive} onChangeUpfront={() => setUpfrontOpen(true)} cartData={cartData} refresh={cartRefresh}  onCartChange={triggerCartRefresh}  customItemProduct={offlineCan('customItems') ? customItemProduct : null}  onEditCartItem={handleCartItemEdit} LoadDishesByDeals={LoadDishesByDeals} editOrderId={editOrderId} existingTakeawayOrderId={displayOrderId} tableName={tableName} tabId={tabId} isPagerOrder={isPagerOrder} onDealChildDelete={handleDealChildDelete} onDealAddItem={handleDealAddItem} onExistingOrderResolved={(orderId, tableId) => setResolvedExistingOrder({ orderId, tableId })} />
                        </div>
                    </div>
                </div>
            </div>
            {isModalOpen && (
  <EditModal
    item={selectedItem}
    isOpen={isModalOpen}
    onClose={closeModal}
    onCartChange={triggerCartRefresh}
    orderType={orderType}
    editOrderId={editOrderId}
    onPendingAdd={cartData.addPendingRow}
    onPendingSettle={cartData.settlePendingRow}
    onPendingFail={cartData.failPendingRow}
  />
)}


     <DealPopupModal
        isOpen={dealPopup.isOpen}
        onClose={closeDealPopup}
        dealId={dealPopup.dealId}
        dealSizeId={dealPopup.dealSizeId}
        onCartChange={triggerCartRefresh}
        orderType={orderType}
        editOrderId={editOrderId}
        initialSelections={dealPopup.remaining}
        deletedProductId={dealPopup.deletedProductId}
        existingParentCartId={dealPopup.parentCartId}
        onPendingAddDeal={cartData.addPendingDeal}
        onPendingSettle={cartData.settlePendingRow}
        onPendingFail={cartData.failPendingRow}
      />

     <HalfNHalfModal
        isOpen={showHalfNHalf}
        onClose={() => setShowHalfNHalf(false)}
        orderType={orderType}
        editOrderId={editOrderId}
        onCartChange={triggerCartRefresh}
        onPendingAddHalf={cartData.addPendingHalf}
        onPendingSettle={cartData.settlePendingRow}
        onPendingFail={cartData.failPendingRow}
      />

     {upfrontActive && (
       <UpfrontOrderSetupModal
         isOpen={upfrontOpen}
         initial={upfrontSetup}
         onSave={handleUpfrontSave}
         onSkip={handleUpfrontSkip}
       />
     )}

     <GuardedNavigationModal
        isOpen={showModal}
        onCancel={cancelNavigation}
        onConfirm={handleConfirm}
      />
      <div className="backDrop" onClick={closeOverlays}></div>
        </MainLayoutWithoutFooter>
    );
};

export default Takeaway;